import {useState} from 'react';

const AboutProgram = ({image, title, description, link, classes}) => {
    const [bottom, setBottom] = useState({});

    const showBottom = () => {
        setBottom({
            transform: 'scaleX(1)',
        });
    };

    const hideBottom = () => {
        setBottom({
            transform: 'scaleX(0)',
        })
    };

    return (
        <div className={`flex flex-col h-full justify-start transition-all duration-1000 ${classes}`}>
            <img src={image} alt="" height={'120px'} width={'120px'} className={"mt-6"}/>
            <h2 className={"mt-6 uppercase text-xl aboutprogram__title"}>{title.toUpperCase()}</h2>
            <p className={"mt-4 w-60 text-sm aboutprogram__description"}>{description}</p>
            <a href={link.href}
              className={"mt-4 text-sm no-underline aboutprogram__link"}
              onMouseEnter={showBottom}
              onMouseLeave={hideBottom}>{link.text.toUpperCase()}</a>
            <span className={'h-px w-44 mt-3 transition-all duration-500 scale-0 origin-left aboutprogram__bottom'} style={bottom}/>
        </div>
    );
};

export default AboutProgram;
